import {formatNumber} from '../../../../components/util'

type props = {
  titulo: string | any
  texto: string
  subtitulo?: string
}

export default function BoxValores({titulo, texto, subtitulo}: props) {
  return (
    <>
      {' '}
      <div
        className='card bgi-no-repeat card-xl-stretch mb-xl-8 border-2 box-performance'
        style={{
          backgroundPosition: 'right top',
          backgroundSize: '30%',
          backgroundImage: "url('/media/svg/shapes/abstract-4.svg')",
        }}
      >
        <div className='card-body'>
          <p className='text-gray-900-75 fw-semibold fs-1 m-0'>{texto}</p>
          <div className='card-title fw-bold fs-5'>{titulo}</div>
          <small>{subtitulo}</small>
        </div>
      </div>
    </>
  )
}
